import {
  obterConfiguracaoAdd,
  obterConfiguracaoBase,
  obterConfiguracaoDeletar,
  ObterConfiguracaoEditar,
} from "./configuracao-tabela-base";

export function obterConfiguracaoEnderecos(listaEstados) {
  const base = obterConfiguracaoBase();

  return {
    ...base,
    add: obterConfiguracaoAdd(),
    edit: ObterConfiguracaoEditar(),
    delete: obterConfiguracaoDeletar(),
    columns: {
      uf: _obterColunaEstadoColuna(listaEstados),
      cidade: { title: "Cidade", filter: false },
      cep: { title: "CEP", filter: false },
      logradouro: { title: "Logradouro", filter: false },
    },
  };
}

function _obterColunaEstadoColuna(listaEstados) {
  const edicaoAbaEndereco = {
    type: "list",
    config: { selectText: "Selecione...", list: listaEstados },
  };
  
  const colunaEndereco = {
    title: "UF",
    editor: edicaoAbaEndereco,
    filter: false,
    filterFunction(value, filter) {
      return filter === value;
    },
  };

  return colunaEndereco;
}
